import { render, staticRenderFns } from "./BlockedPhrasesEditPopup.vue?vue&type=template&id=4d7e97c6"
import script from "./BlockedPhrasesEditPopup.vue?vue&type=script&lang=js"
export * from "./BlockedPhrasesEditPopup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports